import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { StorageAction } from '../models/client-configuration';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  actionStack: StorageAction[] = [];

  private storage: Storage;

  constructor(private logger: LoggerService) {}

  init(useSessionStorage: boolean) {
    this.storage = useSessionStorage ? sessionStorage : localStorage;

    if (useSessionStorage) {
      this.logger.info('Using sessionStorage for user related data');

      if (this.actionStack.length) {
        this.logger.info(`Migrating ${this.actionStack.length} action(s) from localStorage to sessionStorage`);
        this.actionStack.forEach((a) => {
          if (a.action === 'set') {
            this.storage.setItem(a.key, a.value);
            localStorage.removeItem(a.key);
          }
        });
      }
    }
  }

  get(key: string): string {
    return this.getGuard(key);
  }

  set(key: string, value: string) {
    this.setGuard(key, value);
  }

  remove(key: string) {
    this.removeGuard(key);
  }

  private getGuard(key: string): string {
    if (this.storage) {
      return this.storage.getItem(key);
    }

    const sessionValue = sessionStorage.getItem(key);
    return sessionValue || localStorage.getItem(key);
  }

  private setGuard(key: string, value: string) {
    if (this.storage) {
      return this.storage.setItem(key, value);
    }

    localStorage.setItem(key, value);
    this.actionStack.push({ action: 'set', key: key, value: value });
  }

  private removeGuard(key: string) {
    if (this.storage) {
      return this.storage.removeItem(key);
    }

    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  }
}
